"use strict";

exports.__esModule = true;
exports.defaults = exports.props = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
utils for accepting DOM elements or react components
as component type to use for rendering
*/
var props = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].any]);

exports.props = props;
var defaults = 'div';
exports.defaults = defaults;